import React, { useState } from 'react';
import styled from 'styled-components'
import useAsyncEffect from 'use-async-effect';
import moment from 'moment';
import api from '../../api/api';
import { GetUsersResult, UserItem } from '../../model/GetUsersResult';
import { Link } from 'react-router-dom';
import SortableTable from '../table/SortableTable';
const Style = styled.div`

.row {
    margin: 1rem 0;
}
table {
    margin-top: 1rem;
    width: 100%;
}
`;

// epoch for never-logged-in so the Date sort in SortableTable stays total
const toRow = (x:UserItem) => {
    const lastLogin = x.lastLogin ? new Date(x.lastLogin) : new Date(0);
    return [x.username, lastLogin, x.tickers.join(', '), x];
}

const cellFormatter = (columnName:string, cell:any, rowModel:UserItem) => {
    if(columnName === 'Email') return <Link to={`/${rowModel.id}`}>{cell}</Link>;
    if(columnName === 'Last Login') return <>{cell.getTime() === 0 ? 'never' : moment(cell).format('D MMM YY HH:mm')}</>;
    return null;
}

const UsersPage:React.FC = () => {

    const [ result, setResult ] = useState<GetUsersResult>();
    useAsyncEffect(async (isMounted)=>{
        const result = await api().getUsers();
        if(isMounted()){
            setResult(result)
        }
    }, []);



    return <Style>
        <h2>Users</h2>
        <div><Link to={`/users/new`}><button>Add New User</button></Link></div>
        { !!result && <SortableTable
            headers={['Email', 'Last Login', 'Stocks']}
            data={result.users.map(toRow)}
            sortIndex={1}
            sortDirection='desc'
            cellFormatter={cellFormatter}
            /> }
    </Style>
}

export default UsersPage;
